import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe36ee78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-mb-[40px] tw-text-[25px] tw-text-[#211F58] tw-font-semibold tw-leading-[25px]" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "tw-flex tw-w-full tw-gap-[10px] tw-items-center" }
const _hoisted_4 = { class: "tw-self-end tw-mb-[1px]" }
const _hoisted_5 = { class: "tw-flex" }
const _hoisted_6 = { class: "tw-max-w-[115px] tw-truncate" }
const _hoisted_7 = { class: "tw-mt-[12px] tw-mb-[20px] tw-w-full tw-flex tw-items-center tw-justify-between" }
const _hoisted_8 = {
  key: 0,
  class: "tw-pl-[25px] tw-mb-[2px]"
}
const _hoisted_9 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_10 = { class: "tw-pr-[64px]" }
const _hoisted_11 = { class: "tw-text-[13px] tw-underline" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.6251 0.500122H7.62519C7.55071 0.50002 7.47794 0.522396 7.41639 0.564323C7.35484 0.606249 7.30737 0.665776 7.2802 0.735116C7.25178 0.80293 7.24422 0.877673 7.25846 0.949805C7.27271 1.02194 7.30813 1.08819 7.3602 1.14011L9.00015 2.75506L4.27528 7.40495C4.18215 7.49862 4.12988 7.62535 4.12988 7.75744C4.12988 7.88953 4.18215 8.01625 4.27528 8.10993C4.32158 8.15717 4.3768 8.19475 4.43774 8.2205C4.49867 8.24625 4.56411 8.25965 4.63027 8.25992C4.76073 8.26071 4.88633 8.21047 4.98026 8.11993L9.72014 3.45505L11.3651 5.07501C11.3997 5.11006 11.441 5.13785 11.4865 5.15674C11.532 5.17562 11.5808 5.18524 11.6301 5.185C11.68 5.18516 11.7294 5.17494 11.7751 5.155C11.8426 5.12627 11.9 5.07813 11.94 5.01671C11.9801 4.95528 12.001 4.88334 12.0001 4.81001V0.875113C11.9988 0.776062 11.9589 0.681432 11.8888 0.611387C11.8188 0.541341 11.7241 0.501417 11.6251 0.500122Z",
    fill: "#387DFF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.24976 5.81004C9.11716 5.81004 8.98998 5.86272 8.89622 5.95649C8.80245 6.05025 8.74978 6.17743 8.74978 6.31003V11.4999H0.999974V3.7501H6.18484C6.31745 3.7501 6.44462 3.69742 6.53839 3.60365C6.63215 3.50989 6.68483 3.38271 6.68483 3.25011C6.68483 3.1175 6.63215 2.99033 6.53839 2.89657C6.44462 2.8028 6.31745 2.75012 6.18484 2.75012H0.934976C0.687005 2.75012 0.44919 2.84863 0.273848 3.02397C0.0985061 3.19931 0 3.43713 0 3.6851L0 11.5599C-3.51443e-06 11.8083 0.0983428 12.0467 0.273543 12.2228C0.448742 12.3989 0.686546 12.4986 0.934976 12.4999H8.80977C9.05907 12.4999 9.29816 12.4008 9.47444 12.2246C9.65072 12.0483 9.74975 11.8092 9.74975 11.5599V6.31003C9.74975 6.17743 9.69707 6.05025 9.60331 5.95649C9.50954 5.86272 9.38237 5.81004 9.24976 5.81004Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_13 = {
  class: "md:tw-p-10 tw-p-3",
  style: {"background-color":"#fcfcfd"}
}
const _hoisted_14 = { class: "tw-mb-[30px]" }
const _hoisted_15 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_16 = { style: {"background-color":"white"} }
const _hoisted_17 = { class: "tw-p-[15px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md" }
const _hoisted_18 = { class: "tw-p-[15px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_19 = { class: "tw-p-[15px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-b-md" }
const _hoisted_20 = { class: "tw-mb-[30px]" }
const _hoisted_21 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_22 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-t-md" }
const _hoisted_23 = { class: "tw-flex-1" }
const _hoisted_24 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_25 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_26 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_27 = { class: "tw-flex-1" }
const _hoisted_28 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_29 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_30 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_31 = { class: "tw-flex-1" }
const _hoisted_32 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_33 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_34 = { class: "tw-flex tw-items-center tw-px-[15px] tw-py-[12px] tw-border-b-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_35 = { class: "tw-flex-1" }
const _hoisted_36 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_37 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_38 = {
  style: {"border-bottom-left-radius":"6px","border-bottom-right-radius":"6px"},
  class: "tw-flex tw-items-center tw-px-[15px] tw-py-[24px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_39 = { class: "tw-flex-1" }
const _hoisted_40 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_41 = { class: "tw-mb-[30px]" }
const _hoisted_42 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_43 = { class: "tw-flex-1" }
const _hoisted_44 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_45 = { class: "tw-flex-1 tw-flex" }
const _hoisted_46 = { class: "tw-flex-1 tw-text-[13px] tw-text-[#B7B7B7] tw-font-[400] tw-text-end" }
const _hoisted_47 = { class: "tw-ml-[6px] tw-text-[#878787] tw-font-[500]" }
const _hoisted_48 = { class: "tw-flex tw-items-center tw-p-[24px] tw-border-b-[0px] tw-border-t-[0px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]" }
const _hoisted_49 = { class: "tw-flex-1" }
const _hoisted_50 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_51 = { class: "tw-flex-1 tw-flex" }
const _hoisted_52 = { class: "tw-flex-1 tw-text-[13px] tw-text-[#B7B7B7] tw-font-[400] tw-text-end" }
const _hoisted_53 = { class: "tw-ml-[6px] tw-text-[#878787] tw-font-[500]" }
const _hoisted_54 = {
  style: {"border-bottom-left-radius":"6px","border-bottom-right-radius":"6px"},
  class: "tw-flex tw-items-center tw-p-[24px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_55 = { class: "tw-flex-1" }
const _hoisted_56 = { class: "tw-text-[13px] tw-min-w-[110px] tw-font-[500]" }
const _hoisted_57 = { class: "tw-flex-1 tw-flex" }
const _hoisted_58 = { class: "tw-mb-[30px]" }
const _hoisted_59 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_60 = { class: "tw-mb-[30px]" }
const _hoisted_61 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_62 = { class: "tw-mb-[30px]" }
const _hoisted_63 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_64 = { class: "tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold" }
const _hoisted_65 = { class: "tw-px-[20px] tw-py-[18px] tw-bg-white tw-rounded-md tw-border-solid tw-border-[1px] tw-border-[#EFF0F1]" }
const _hoisted_66 = {
  key: 0,
  class: "tw-m-0 tw-text-[13px] tw-text-[#b7b7b7]"
}
const _hoisted_67 = { class: "tw-justify-end tw-w-full tw-flex tw-pb-[15px] tw-pr-[40px]" }
const _hoisted_68 = { class: "tw-text-[#B7B7B7] tw-font-[Poppins] tw-text-[13px] tw-leading-normal" }

import {
  IAssessmentChecklistItem,
  IAssessmentQuestionType,
} from "@/interfaces/assessments/IAssessmentDetails";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  MODAL_NAME,
  SCORE_TYPE,
  TYPE_MODAL_SECURING_EVIDENCE,
  assessmentAdditionalInfoType,
  assessmentQuestionAnswerType,
  assessmentQuestionVisibleState,
  checklistStatusId,
  localStorageKey,
  routers,
  statusCode,
} from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { PropType, Ref, computed, onMounted, onUnmounted, ref } from "vue";
import AssessmentAnswerType1 from "../assessments/assessmentAnswerType1.vue";
import CustomBDropDown from "../common/customBDropDown.vue";
import CustomBDropDownItem from "../common/customBDropDownItem.vue";
import CircularProgressPercent from "../common/circularProgressPercent.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import PercentInput from "../common/percentInput.vue";
import { CHECKLIST_ICON_VALUE_WITH_COLOR } from "@/utils/constants";
import Cost from "../svgs/cost.vue";
import Importance from "../svgs/importance.vue";
import Impact from "../svgs/impact.vue";
import Effort from "../svgs/effort.vue";
import categoryWeighting from "../svgs/categoryWeighting.vue";
import PotentialScoreIcon from "../svgs/potentialScoreIcon.vue";
import IncreaseIcon from "../svgs/increaseIcon.vue";
import Score from "../svgs/score.vue";
import store from "@/store";
import {
  convertComplianceInputValue,
  getCheckListStatusDetails,
  postToggleChecklistItems,
} from "@/services/assessment";
import StatusBadge from "../common/setting/statusBadge.vue";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import { watch } from "vue";
import Button4 from "../common/button4.vue";
import { Checklist } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import AssessmentAdditionalInfo from "../assessments/assessmentAdditionalInfo.vue";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { Handler } from "mitt";
import WysiwygEditor from "../common/wysiwygEditor.vue";

const colorTextExclude = "#231F20";
const inputLabelGray = "!tw-text-[#878787] tw-text-[13px] tw-font-normal";
const inputLabelBlack = "!tw-text-[#231F20] tw-text-[13px] tw-font-normal";

export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentAdvanced',
  props: {
  questionData: {
    type: Object as PropType<IAssessmentChecklistItem>,
    default: () => ({}),
  },
  checklistId: {
    type: Number,
    default: 0,
  },
  checklistItemId: {
    type: Number,
    default: 0,
  },
  answerOptionsDropDown: {
    type: Array as PropType<any[]>,
    default: () => [],
  },
  answerOption: {
    type: Object as PropType<any>,
    default: () => {},
  },
  isRecommend: {
    type: Boolean,
    default: false,
  },
  isGlobalSearch: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: false,
  },
  passkey: {
    type: String,
    default: "",
  },
},
  emits: ["show", "close"],
  setup(__props, { emit }) {

const props = __props;



const checklistItemData = computed(() => {
  if (props.isRecommend && !props.isGlobalSearch) {
    return {
      ...props.questionData,
      ...store.getters["Recommend/getCurrentChecklistItem"](props.questionData),
    };
  }

  if (props.isGlobalSearch) {
    return {
      ...store.state.Assessment.currentChecklistAdvanced.questionData,
      ...store.getters["Assessment/getCurrentChecklistItem"](
        store.state.Assessment.currentChecklistAdvanced.checklistItemId,
        store.state.Assessment.currentChecklistAdvanced?.isGlobalSearch,
      ),
    };
  }

  return {
    ...props.questionData,
    ...store.getters["Assessment/getCurrentChecklistItem"](
      props.checklistItemId,
      props.isGlobalSearch,
    ),
  };
});

const answerOptionsDropDown = computed(() => {
  if (props.isGlobalSearch)
    return store.state.Assessment.currentChecklistAdvanced
      .answerOptionsDropDown;
  else return props.answerOptionsDropDown;
});

const answerOption = computed(() => {
  if (props.isGlobalSearch)
    return store.state.Assessment.currentChecklistAdvanced.answerOption;
  else return props.answerOption;
});

const isRecommend = computed(() => {
  if (props.isGlobalSearch)
    return store.state.Assessment.currentChecklistAdvanced.isRecommend;
  else return props.isRecommend;
});

const passkey = computed(() => {
  if (props.isGlobalSearch)
    return store.state.Assessment.currentChecklistAdvanced.passkey;
  else return props.passkey;
});



const parentGroupings = [
  "checklistItemIdParentGrouping4",
  "checklistItemIdParentGrouping3",
  "checklistItemIdParentGrouping2",
  "checklistItemIdParentGrouping1",
];

const checklistItemComplianceTypeValue: Ref<string> = ref("");
const checklistItemComplianceOverride: Ref<string> = ref("");
const checklistItemCompensatingControlValue: Ref<string> = ref("");
const noteData: Ref<string> = ref(checklistItemData.value.checklistItemNotes);
const descriptionData: Ref<string> = ref(
  checklistItemData.value.checklistItemDescription,
);
const autoTextarea = ref<HTMLTextAreaElement | null>(null);
const autoTextareaDes = ref<HTMLTextAreaElement | null>(null);
let currentNote = "";
let currentDescription = "";

const defaultComplianceClass = computed(() =>
  (checklistItemData.value.checklistItemComplianceTypeValue ||
    checklistItemData.value.checklistItemComplianceTypeValue === 0) &&
  !checklistItemData.value.checklistItemComplianceOverride &&
  !checklistItemData.value.checklistItemCompensatingControlValue &&
  !isExclude.value
    ? inputLabelBlack
    : inputLabelGray,
);

const defaultOverrideClass = computed(() =>
  (checklistItemData.value.checklistItemComplianceOverride ||
    checklistItemData.value.checklistItemComplianceOverride === 0) &&
  !checklistItemData.value.checklistItemCompensatingControlValue &&
  !isExclude.value
    ? inputLabelBlack
    : inputLabelGray,
);

const defaultControlClass = computed(() =>
  (checklistItemData.value.checklistItemCompensatingControlValue ||
    checklistItemData.value.checklistItemCompensatingControlValue === 0) &&
  !isExclude.value
    ? inputLabelBlack
    : inputLabelGray,
);

const isExclude = computed(() => {
  return (
    checklistItemData.value.visibleState === assessmentQuestionVisibleState.no
  );
});

const isChecklistCompleted: Ref<boolean> = ref(false);

const checklistId = computed(() => {
  return isRecommend.value && !props.isGlobalSearch
    ? store.getters["Recommend/getChecklistReportId"]
    : store.getters["Assessment/getCurrentChecklistId"];
});

const parentCheckList = computed(() => {
  let getParent = null;
  for (const grouping of parentGroupings) {
    if (checklistItemData.value[grouping]) {
      getParent = checklistItemData.value[grouping];
      break;
    }
  }
  return store.getters["Assessment/getCurrentChecklistItem"](getParent);
});
const answerRadioRef: Ref<any> = ref(null);
const answerOptionRef: Ref<IDropDownData[]> = ref([]);
const answerOptionDropdownRef: Ref<any[]> = computed(
  () => answerOptionsDropDown.value,
);
const importanceRef: Ref<IDropDownData[]> = ref([]);
const costRef: Ref<IDropDownData[]> = ref([]);
const impactRef: Ref<IDropDownData[]> = ref([]);
const effortRef: Ref<IDropDownData[]> = ref([]);
const passkeyQuestion: Ref<any> = computed(() => passkey.value);
const onHover = ref(false);
const importanceDropdownData: any = computed(
  () => store.state.Assessment.importanceAssessment,
);
const impactDropdownData: any = computed(
  () => store.state.Assessment.impactAssessment,
);
const effortDropdownData: any = computed(
  () => store.state.Assessment.effortAssessment,
);
const costDropdownData: any = computed(
  () => store.state.Assessment.costAssessment,
);
const prospectQuestionTypes: Ref<IAssessmentQuestionType[]> = computed(
  () => store.state.Assessment.assessmentQuestionTypes,
);

let classImportanceName = ref("");
let classCostName = ref("");
let classImpactName = ref("");
let classEffortName = ref("");
let setTimeOutRef: any = null;

onMounted(() => {
  initialData();
  resizeInput();
});

watch(
  () => checklistId.value,
  (newValue) => {
    if (newValue) {
      getChecklistStatusDetail(newValue);
    }
  },
);

// Update prefill answer when user changes checklist in global search.
watch(
  () => store.state.Assessment.currentChecklistAdvanced,
  () => {
    handlePrefillAnswer();
    handlePrefillNoteAndDescription();
  },
  { deep: true },
);

const handlePrefillNoteAndDescription = () => {
  descriptionData.value =
    checklistItemData.value.checklistItemDescription || "";
  noteData.value = checklistItemData.value.checklistItemNotes || "";
};

const getChecklistStatusDetail = async (checklistId: number) => {
  try {
    const res: any = await getCheckListStatusDetails(checklistId);
    const statusId = res.data.data.checklistStatusId;

    isChecklistCompleted.value =
      statusId === checklistStatusId.completed ||
      statusId === checklistStatusId.paused ||
      statusId === checklistStatusId.defunct;
  } catch (error) {
    console.error(error);
  }
};

const initialData = async () => {
  if (checklistId.value) {
    getChecklistStatusDetail(checklistId.value);
  }

  if (!prospectQuestionTypes.value.length) {
    store.dispatch("Assessment/fetchAssessmentQuestionTypes");
  }

  if (!importanceDropdownData.value.length) {
    await Promise.all([
      store.dispatch("Assessment/fetchImportanceAssessment"),
      store.dispatch("Assessment/fetchImpactAssessment"),
      store.dispatch("Assessment/fetchEffortAssessment"),
      store.dispatch("Assessment/fetchCostAssessment"),
    ]);
  }
  checklistItemComplianceTypeValue.value =
    typeof checklistItemData.value.checklistItemComplianceTypeValue === "number"
      ? (
          checklistItemData.value.checklistItemComplianceTypeValue * 100
        ).toString()
      : "";

  checklistItemComplianceOverride.value =
    typeof checklistItemData.value.checklistItemComplianceOverride === "number"
      ? (
          checklistItemData.value.checklistItemComplianceOverride * 100
        ).toString()
      : "";

  checklistItemCompensatingControlValue.value =
    typeof checklistItemData.value.checklistItemCompensatingControlValue ===
    "number"
      ? (
          checklistItemData.value.checklistItemCompensatingControlValue * 100
        ).toString()
      : "";

  handlePrefillAnswer();
  getPasskey();
};

const getPasskey = () => {
  EventEmitter.on(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, ((data: {
    password: string;
    checklistItemId: number;
  }) => {
    if (
      data.password &&
      data.checklistItemId === checklistItemData.value.checklistItemId
    ) {
      passkeyQuestion.value = data.password;
    }
  }) as Handler<unknown>);
};

const handleExclude = async () => {
  if (isChecklistCompleted.value) return;
  try {
    await postToggleChecklistItems(checklistId.value, [
      checklistItemData.value.checklistItemId,
    ]);
    await store.dispatch("Assessment/updateCheckListItems", {
      checklistId: checklistId.value,
      checklistItemIds: [checklistItemData.value.checklistItemId],
      type: ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM,
    });
  } catch (error: any) {
    showErrorAPI(error, Checklist.toggleChecklistToItem);
  }
};

const handlePrefillAnswer = async () => {
  if (
    checklistItemData.value.answerType === assessmentQuestionAnswerType.select
  ) {
    answerOption.value && (answerOptionRef.value = [...answerOption.value]);
  }

  if (checklistItemData.value.answerType === assessmentQuestionAnswerType.radio)
    answerRadioRef.value =
      checklistItemData.value.checklistItemComplianceTypeValue;

  if (isRecommend.value && !props.isGlobalSearch) {
    const questionType = checklistItemData.value.checklistItemComplianceTypeId;
    const data = prospectQuestionTypes.value.find(
      (item) => item.id === questionType,
    );
    if (data) answerOptionDropdownRef.value = data.complianceTypeValues;
    else answerOptionDropdownRef.value = [];

    answerOptionDropdownRef.value = answerOptionDropdownRef.value.map(
      (option: any) => {
        const item = {
          ...option,
          name: option.label,
        };
        return item;
      },
    );

    answerOptionRef.value = [
      answerOptionDropdownRef.value.find(
        (item) =>
          item.value ==
          checklistItemData.value.checklistItemComplianceTypeValue,
      ),
    ];
  }

  checklistItemData.value.checklistItemImportance &&
    ((importanceRef.value = findSeclectById(
      checklistItemData.value.checklistItemImportanceId,
      importanceDropdownData.value,
    )),
    (classImportanceName.value = checklistItemData.value
      .checklistItemImportanceId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[
          checklistItemData.value.checklistItemImportanceId
        ]
      : "tw-text-[#231F20]"));

  checklistItemData.value.checklistItemCost &&
    ((costRef.value = findSeclectById(
      checklistItemData.value.checklistItemCostId,
      costDropdownData.value,
    )),
    (classCostName.value = checklistItemData.value.checklistItemCostId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[
          checklistItemData.value.checklistItemCostId
        ]
      : "tw-text-[#231F20]"));

  checklistItemData.value.checklistItemImpact &&
    ((impactRef.value = findSeclectById(
      checklistItemData.value.checklistItemImpactId,
      impactDropdownData.value,
    )),
    (classImpactName.value = checklistItemData.value.checklistItemImpactId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[
          checklistItemData.value.checklistItemImpactId
        ]
      : "tw-text-[#231F20]"));

  checklistItemData.value.checklistItemEffort &&
    ((effortRef.value = findSeclectById(
      checklistItemData.value.checklistItemEffortId,
      effortDropdownData.value,
    )),
    (classEffortName.value = checklistItemData.value.checklistItemEffortId
      ? CHECKLIST_ICON_VALUE_WITH_COLOR[
          checklistItemData.value.checklistItemEffortId
        ]
      : "tw-text-[#231F20]"));
};

const handleScoreSeclected = (event: IDropDownData, scoreType) => {
  const score = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  let typeAnswer = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPORTANCE;
  switch (scoreType) {
    case SCORE_TYPE.IMPORTANCE:
      importanceRef.value = [event];
      classImportanceName.value = score;
      typeAnswer = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPORTANCE;
      break;
    case SCORE_TYPE.IMPACT:
      impactRef.value = [event];
      classImpactName.value = score;
      typeAnswer = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPACT;
      break;
    case SCORE_TYPE.COST:
      costRef.value = [event];
      classCostName.value = score;
      typeAnswer = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_COST;
      break;
    case SCORE_TYPE.EFFORT:
      effortRef.value = [event];
      classEffortName.value = score;
      typeAnswer = ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_EFFORT;
      break;
  }

  updateAnswer({
    checklistId: checklistItemData.value.checklistId,
    checklistItemId: checklistItemData.value.checklistItemId,
    answer: event.id,
    type: typeAnswer,
  });
};

const updateAnswer = (data: any) => {
  if (isRecommend.value && !props.isGlobalSearch) {
    store.dispatch("Recommend/updateAnswer", {
      data,
      checklistItemData: checklistItemData.value,
    });
  } else {
    store.dispatch("Assessment/updateAnswer", {
      ...data,
      isGlobalSearch: props.isGlobalSearch,
    });
  }
};

const linkInAssessment = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const id = checklistId.value;
  localStorage.setItem(
    localStorageKey.assessmentSearchTerm,
    checklistItemData.value.checklistItemName,
  );
  if (checklistItemData.value.checklistItemCategoryId) {
    localStorage.setItem(
      localStorageKey.assessmentActiveCategory,
      checklistItemData.value.checklistItemCategoryId,
    );
    store.dispatch(
      "Assessment/changeActiveCategory",
      checklistItemData.value.checklistItemCategoryId,
    );
  } else {
    localStorage.removeItem(localStorageKey.assessmentActiveCategory);
    store.dispatch("Assessment/changeActiveCategory", null);
  }
  window.open(
    `${baseUrl}${
      routers.assessChecklist
    }?checklistId=${id}&reload=${!!checklistItemData.value
      .checklistItemCategoryId}`,
  );
};

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};

const handleAnswer = (event: any) => {
  if (
    checklistItemData.value.answerType === assessmentQuestionAnswerType.select
  ) {
    answerOptionRef.value = [
      answerOptionDropdownRef.value.find((item) => item.value == event),
    ];
  }

  if (checklistItemData.value.answerType === assessmentQuestionAnswerType.radio)
    answerRadioRef.value = event;

  updateAnswer({
    checklistId: checklistItemData.value.checklistId,
    checklistItemId: checklistItemData.value.checklistItemId,
    answer: event,
    type: ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE,
  });
};

const onBlur = (type: any) => {
  let answer = checklistItemData.value[type];
  updateAnswer({
    checklistId: checklistItemData.value.checklistId,
    checklistItemId: checklistItemData.value.checklistItemId,
    answer,
    type,
  });
};

const findSeclectById = (id: any, arrayScore: any) => {
  return [arrayScore.find((item) => item.id === id)];
};

const openEvidenceModal = () => {
  if (
    !passkeyQuestion.value &&
    checklistItemData.value.checklistItemAttachments?.length
  ) {
    openSecuringModal();
  } else {
    openEvidence();
  }
};

const openSecuringModal = () => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type: TYPE_MODAL_SECURING_EVIDENCE.DECRYPT,
      checklistItemId: checklistItemData.value.checklistItemId,
      attachmentId: checklistItemData.value?.checklistItemAttachments[0]?.id,
    },
    events: {
      "update:data": (passkey, file) => {
        passkeyQuestion.value = passkey;
        openEvidence();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openEvidence = () => {
  if (
    isChecklistCompleted.value &&
    checklistItemData.value.checklistItemAttachments.length === 0
  )
    return;

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_EVIDENCE,
    properties: {
      value: {
        questionNumber: checklistItemData.value.orderNumber,
        questionTitle: `${checklistItemData.value.checklistItemName}${
          checklistItemData.value.subName
            ? ` | ${checklistItemData.value.subName}`
            : ""
        }`,
        category: checklistItemData.value.checklistItemComplianceTypeLabel,
        subCategory:
          checklistItemData.value.checklistItemHeadingLabel ||
          checklistItemData.value.checklistItemName ||
          "",
        checklistId: checklistItemData.value.checklistId,
        checklistItemId: checklistItemData.value.checklistItemId,
      },
      dataTableFile: checklistItemData.value.checklistItemAttachments?.filter(
        (i: any) => i.type === assessmentAdditionalInfoType.attachment,
      ),
      passkey: passkeyQuestion.value,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const updateNoteAssessement = (value) => {
  if (currentNote === noteData.value || value === undefined) return;
  store.dispatch("Assessment/updateAnswer", {
    checklistId: checklistItemData.value.checklistId,
    checklistItemId: checklistItemData.value.checklistItemId,
    answer: noteData.value,
    type: ASSESSMENT_ANSWER_STORE_TYPE.NOTES,
  });
};

const updateDescriptionAssessement = (value) => {
  if (
    currentDescription === descriptionData.value ||
    descriptionData.value === undefined
  )
    return;
  store.dispatch("Assessment/updateAnswer", {
    checklistId: checklistItemData.value.checklistId,
    checklistItemId: checklistItemData.value.checklistItemId,
    answer: descriptionData.value,
    type: ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_DESCRIPTION,
  });
};

const onFocus = () => {
  currentNote = noteData.value;
};

const onFocusDes = () => {
  currentDescription = descriptionData.value;
};

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "57.5px"; // Reset height
    autoTextarea.value.style.height =
      autoTextarea.value.scrollHeight + 1.5 + "px"; // Set height based on content
  }
};

const autoResizeDes = () => {
  if (autoTextareaDes.value) {
    autoTextareaDes.value.style.height = "57.5px"; // Reset height
    autoTextareaDes.value.style.height =
      autoTextareaDes.value.scrollHeight + 1.5 + "px"; // Set height based on content
  }
};

const resizeInput = () => {
  autoResize();
  autoResizeDes();
};

onMounted(() => {
  EventEmitter.on(EmitterEvents.CLOSE_ASSESSMENT_ADVANCED_MENU, () =>
    emit("close"),
  );
});

onUnmounted(() => {
  EventEmitter.off(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION);
  EventEmitter.off(EmitterEvents.CLOSE_ASSESSMENT_ADVANCED_MENU);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "tw-p-3 tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] md:tw-p-10",
      onMouseover: onHoverIn,
      onMouseout: onHoverOut
    }, [
      _createElementVNode("p", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-advanced-title-1")), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (checklistItemData.value.checklistItemCategoryLabel)
              ? (_openBlock(), _createBlock(StatusBadge, {
                  key: 0,
                  label: checklistItemData.value.checklistItemCategoryLabel,
                  class: "tw-w-fit",
                  value: isExclude.value ? _unref(statusCode).disable : _unref(statusCode).category
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (checklistItemData.value.checklistItem3ndSubCategoryLabel)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(ButtonShowMore, {
                      "id-popover": 'popover-assessment-advanced-checklist-item-sub-catergory',
                      "is-from-notification": true,
                      classes: '!tw-p-0',
                      "icon-class": '!tw-p-0 !tw-m-0',
                      "dropdown-class": `tw-max-w-max ${
                  isExclude.value
                    ? 'assessment-question-table-item-dropdown-disable'
                    : 'assessment-question-table-item-dropdown'
                }`,
                      "custom-class": "blue-tooltip"
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(StatusBadge, {
                          label: '...',
                          class: "tw-w-fit",
                          value: 
                      isExclude.value ? _unref(statusCode).disable : _unref(statusCode).subCategory
                    
                        }, null, 8, ["label", "value"])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistItemData.value.checklistItem2ndSubCategoryLabel, (text, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: text,
                              class: "tw-flex tw-items-center tw-justify-center"
                            }, [
                              (index > 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(`tw-text-[11px] tw-font-medium ${
                          isExclude.value ? 'tw-text-white' : 'tw-text-[#387DFF]'
                        }`)
                                  }, " > ", 2))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: _normalizeClass(`tw-flex tw-items-center tw-h-[20px] tw-px-[5px] tw-bg-[#E4F1FF] tw-rounded tw-text-[11px] tw-font-medium ${
                          isExclude.value ? 'tw-text-white' : 'tw-text-[#387DFF]'
                        }`)
                              }, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(text), 1)
                              ], 2)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }, 8, ["dropdown-class"])
                  ]),
                  _createVNode(StatusBadge, {
                    label: checklistItemData.value.checklistItem3ndSubCategoryLabel?.[0],
                    class: "tw-w-fit",
                    "lable-class": "tw-max-w-[200px]",
                    value: isExclude.value ? _unref(statusCode).disable : _unref(statusCode).subCategory
                  }, null, 8, ["label", "value"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (checklistItemData.value.checklistItem2ndSubCategoryLabel)
                    ? (_openBlock(), _createBlock(StatusBadge, {
                        key: 0,
                        label: 
                checklistItemData.value.checklistItem2ndSubCategoryLabel?.[0]
                  ? checklistItemData.value.checklistItem2ndSubCategoryLabel?.[0]
                  : _unref(getComponentUiText)(
                      'app-component-assessments-input-question-other-1',
                    )
              ,
                        "lable-class": "tw-max-w-[200px]",
                        class: "tw-w-fit",
                        value: isExclude.value ? _unref(statusCode).disable : _unref(statusCode).subCategory
                      }, null, 8, ["label", "value"]))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(`tw-flex tw-items-center tw-pr-[10px] ${
              isExclude.value ? 'tw-text-[#231F20]' : 'tw-text-[#211F58]'
            }`)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(`tw-mr-[15px] tw-font-semibold tw-text-[16px] ${
                isExclude.value ? 'tw-opacity-50' : ''
              }`)
              }, _toDisplayString(checklistItemData.value.orderNumber), 3),
              _createElementVNode("span", {
                class: _normalizeClass(`tw-font-normal tw-text-[16px] ${
                isExclude.value ? 'tw-opacity-50' : ''
              }`)
              }, _toDisplayString(checklistItemData.value.checklistItemName) + _toDisplayString(checklistItemData.value.subName
                  ? ` | ${checklistItemData.value.subName}`
                  : ""), 3),
              (checklistItemData.value.checklistItemDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(ButtonShowDuplicateAssessment, {
                      "id-popover": 'popover-assessment-advanced-checklist-item-description',
                      "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                      classes: `!tw-leading-none `
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomDescriptionContent, {
                          description: checklistItemData.value.checklistItemDescription
                        }, null, 8, ["description"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_9, [
              (checklistItemData.value.itemCompleteValue !== undefined)
                ? (_openBlock(), _createBlock(CircularProgressPercent, {
                    key: 0,
                    percent: checklistItemData.value.itemCompleteValue,
                    "compensating-override-score": 
                checklistItemData.value.checklistItemCompensatingControlValue
              ,
                    "compliance-override-score": 
                checklistItemData.value.checklistItemComplianceOverride
              ,
                    excluded: isExclude.value
                  }, null, 8, ["percent", "compensating-override-score", "compliance-override-score", "excluded"]))
                : _createCommentVNode("", true),
              (isExclude.value && !isChecklistCompleted.value)
                ? (_openBlock(), _createBlock(Button4, {
                    key: 1,
                    class: _normalizeClass(`tw-self-center ${
                isChecklistCompleted.value ? '!tw-cursor-not-allowed' : ''
              }`),
                    onClick: handleExclude
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-component-assessments-include-1")), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (
              checklistItemData.value.answerType ===
              _unref(assessmentQuestionAnswerType).radio
            )
              ? (_openBlock(), _createBlock(AssessmentAnswerType1, {
                  key: 0,
                  value: answerRadioRef.value,
                  class: _normalizeClass([isExclude.value ? 'tw-opacity-50' : '']),
                  "on-hover": true,
                  disabled: 
              isChecklistCompleted.value ||
              isExclude.value ||
              checklistItemData.value.checklistItemComplianceOverride !== null ||
              checklistItemData.value.checklistItemCompensatingControlValue !== null
            ,
                  excluded: isExclude.value,
                  onOnUpdate: handleAnswer
                }, null, 8, ["value", "class", "disabled", "excluded"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(`dropdown-container tw-flex-1 dropdown tw-mr-[64px] ${
            isExclude.value ? 'tw-opacity-50' : ''
          }`)
          }, [
            (
              checklistItemData.value.answerType ===
              _unref(assessmentQuestionAnswerType).select
            )
              ? (_openBlock(), _createBlock(CustomBDropDown, {
                  key: 0,
                  id: 'answerOption',
                  disabled: 
              isChecklistCompleted.value ||
              isExclude.value ||
              checklistItemData.value.checklistItemComplianceOverride !== null ||
              checklistItemData.value.checklistItemCompensatingControlValue !== null
            ,
                  data: answerOptionRef.value,
                  "class-name": 
              'gray-dropdown-container tw-h-[58px] ' + 'white-background'
            ,
                  placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-assessment-question-chose-answer-prompt-1',
              )
            
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerOptionDropdownRef.value, (item) => {
                      return (_openBlock(), _createBlock(CustomBDropDownItem, {
                        key: item.id,
                        data: item,
                        "class-name": 'normal-dropdown-container',
                        onClick: ($event: any) => (handleAnswer(item.value))
                      }, null, 8, ["data", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["disabled", "data", "placeholder"]))
              : _createCommentVNode("", true)
          ], 2),
          _withDirectives(_createElementVNode("div", {
            class: "tw-mt-[40px] tw-flex t-gap-[8px] tw-items-center tw-gap-[8px] hover:tw-cursor-pointer tw-w-fit",
            onClick: linkInAssessment
          }, [
            _createElementVNode("a", _hoisted_11, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-advanced-url-view-1")), 1),
            _hoisted_12
          ], 512), [
            [_vShow, isRecommend.value]
          ])
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(getComponentUiText)("app-component-assessments-override-title-1")), 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(PercentInput, {
              value: checklistItemData.value.checklistItemComplianceTypeValue,
              "data-cy-id": "assessment-advance-compliance-value",
              "hint-text": "%",
              label: 
              _unref(getComponentUiText)(
                'app-component-assessments-question-type-2-default-compliance-label-1',
              )
            ,
              "class-text": defaultComplianceClass.value,
              "class-input": '!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]',
              disabled: true,
              "is-show-recommend": false
            }, null, 8, ["value", "label", "class-text", "class-input"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(PercentInput, {
              modelValue: checklistItemComplianceOverride.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checklistItemComplianceOverride).value = $event)),
              value: checklistItemData.value.checklistItemComplianceOverride,
              "data-cy-id": "assessment-advance-compliance-override-value",
              "hint-text": "%",
              label: 
              _unref(getComponentUiText)(
                'app-component-assessments-question-type-2-override-label-1',
              )
            ,
              "class-text": defaultOverrideClass.value,
              "is-show-recommend": false,
              disabled: isChecklistCompleted.value || isExclude.value,
              "class-input": '!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]',
              "onOn:blur": _cache[1] || (_cache[1] = 
              () => {
                checklistItemData.value.checklistItemComplianceOverride =
                  _unref(convertComplianceInputValue)(checklistItemComplianceOverride.value);
                onBlur(_unref(ASSESSMENT_ANSWER_STORE_TYPE).COMPLIANCE_OVERRIDE);
              }
            )
            }, null, 8, ["modelValue", "value", "label", "class-text", "disabled", "class-input"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(PercentInput, {
              modelValue: checklistItemCompensatingControlValue.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((checklistItemCompensatingControlValue).value = $event)),
              value: checklistItemData.value.checklistItemCompensatingControlValue,
              "data-cy-id": "assessment-advance-compensating-value",
              "hint-text": "%",
              "class-text": defaultControlClass.value,
              "is-show-recommend": false,
              "is-show-status": true,
              label: 
              _unref(getComponentUiText)(
                'app-component-assessments-question-type-2-compensating-controls-label-1',
              )
            ,
              disabled: isChecklistCompleted.value || isExclude.value,
              "class-input": '!tw-min-w-[50px] md:!tw-min-w-[80px] !tw-min-h-[44px] tw-text-[13px] tw-font-normal !tw-bg-[rgba(239,240,241,0.5)]',
              "onOn:blur": _cache[3] || (_cache[3] = 
              () => {
                checklistItemData.value.checklistItemCompensatingControlValue =
                  _unref(convertComplianceInputValue)(
                    checklistItemCompensatingControlValue.value,
                  );
                onBlur(_unref(ASSESSMENT_ANSWER_STORE_TYPE).COMPENSATING_CONTROL);
              }
            )
            }, null, 8, ["modelValue", "value", "class-text", "label", "disabled", "class-input"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-question-type-2-icon-tooltip-score-1",
          )), 1),
        _createElementVNode("div", {
          style: {"background-color":"white"},
          class: _normalizeClass(isExclude.value ? 'disable-text tw-opacity-50' : '')
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(Importance, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(getComponentUiText)("app-component-table-header-importance-1")), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(CustomBDropDown, {
                id: 'importanceOption',
                data: importanceRef.value,
                "class-text-name": `${
                isExclude.value
                  ? `tw-text-[${colorTextExclude}]`
                  : _unref(classImportanceName)
              }`,
                "class-name": 
                'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
                'white-background'
              ,
                disabled: isChecklistCompleted.value || isExclude.value,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-component-assessments-assessment-question-chose-answer-prompt-1',
                )
              
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(importanceDropdownData.value, (item, index) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: index,
                      data: item,
                      "class-name": `normal-dropdown-container ${
                  item.id
                    ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                    : 'tw-text-[#231F20]'
                }`,
                      onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).IMPORTANCE))
                    }, null, 8, ["data", "class-name", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "class-text-name", "disabled", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Impact, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-question-type-2-icon-tooltip-impact-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(CustomBDropDown, {
                id: 'impactOption',
                data: impactRef.value,
                disabled: isChecklistCompleted.value || isExclude.value,
                "class-text-name": `${
                isExclude.value ? `tw-text-[${colorTextExclude}]` : _unref(classImpactName)
              }`,
                "class-name": 
                'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
                'white-background'
              ,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-component-assessments-assessment-question-chose-answer-prompt-1',
                )
              
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(impactDropdownData.value, (item, index) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: index,
                      data: item,
                      "class-name": `normal-dropdown-container ${
                  item.id
                    ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                    : 'tw-text-[#231F20]'
                }`,
                      onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).IMPACT))
                    }, null, 8, ["data", "class-name", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "disabled", "class-text-name", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(Cost, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-question-type-2-icon-tooltip-cost-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(CustomBDropDown, {
                id: 'costOption',
                data: costRef.value,
                "class-text-name": `${
                isExclude.value ? `tw-text-[${colorTextExclude}]` : _unref(classCostName)
              }`,
                "class-name": 
                'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
                'white-background'
              ,
                disabled: isChecklistCompleted.value || isExclude.value,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-component-assessments-assessment-question-chose-answer-prompt-1',
                )
              
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costDropdownData.value, (item, index) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: index,
                      data: item,
                      "class-name": `normal-dropdown-container ${
                  item.id
                    ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                    : 'tw-text-[#231F20]'
                }`,
                      onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).COST))
                    }, null, 8, ["data", "class-name", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "class-text-name", "disabled", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(Effort, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-question-type-2-icon-tooltip-effort-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(CustomBDropDown, {
                id: 'effortOption',
                data: effortRef.value,
                "class-text-name": `${
                isExclude.value ? `tw-text-[${colorTextExclude}]` : _unref(classEffortName)
              }`,
                "class-name": 
                'gray-dropdown-container tw-h-[44px] gray-dropdown-container-advance ' +
                'white-background'
              ,
                disabled: isChecklistCompleted.value || isExclude.value,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-component-assessments-assessment-question-chose-answer-prompt-1',
                )
              
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effortDropdownData.value, (item, index) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: index,
                      data: item,
                      "class-name": `normal-dropdown-container ${
                  item.id
                    ? `${_unref(CHECKLIST_ICON_VALUE_WITH_COLOR)[`${item.id}`]}`
                    : 'tw-text-[#231F20]'
                }`,
                      onClick: ($event: any) => (handleScoreSeclected(item, _unref(SCORE_TYPE).EFFORT))
                    }, null, 8, ["data", "class-name", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "class-text-name", "disabled", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(categoryWeighting, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ])
              }),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-assessment-question-category-weighting-1",
              )), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
              'tw-flex-1 tw-text-[13px]',
              isExclude.value ? 'disable-text' : 'tw-text-[#231F20]',
            ])
            }, _toDisplayString(Math.round(
                checklistItemData.value?.checklistItemCategoryWeightMax * 100,
              )) + "% ", 3)
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-assessment-question-total-score-1",
          )), 1),
        _createElementVNode("div", {
          style: {"background-color":"white"},
          class: _normalizeClass(isExclude.value ? 'disable-text tw-opacity-50' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`tw-flex tw-items-center tw-p-[24px] tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] ${
            isRecommend.value ? 'tw-rounded-t-md' : 'tw-rounded-md'
          }`)
          }, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(Score, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-assessment-question-current-score-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("span", {
                class: _normalizeClass([
                'tw-flex-1 tw-text-[13px]',
                'tw-font-[500]',
                isExclude.value ? 'disable-text' : 'tw-text-[#F7553C]',
              ])
              }, _toDisplayString(Math.round(checklistItemData.value.checklistItemScore * 100) / 100), 3),
              _createElementVNode("span", _hoisted_46, [
                _createTextVNode(_toDisplayString(Math.round(checklistItemData.value.checklistItemScore * 100) / 100) + "/" + _toDisplayString(Math.round(checklistItemData.value.checklistItemScoreMax * 100) / 100), 1),
                _createElementVNode("span", _hoisted_47, _toDisplayString(Math.round(
                    (checklistItemData.value.checklistItemScore /
                      checklistItemData.value.checklistItemScoreMax) *
                      100,
                  ) || 0) + "%", 1)
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createVNode(PotentialScoreIcon, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-assessment-question-potential-score-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("span", {
                class: _normalizeClass([
                'tw-flex-1 tw-text-[13px]',
                'tw-text-[#01893D] tw-font-[500]',
                isExclude.value ? 'disable-text' : 'tw-text-[#01893D]',
              ])
              }, _toDisplayString(Math.round(checklistItemData.value.checklistItemScoreMax * 100) / 100), 3),
              _createElementVNode("span", _hoisted_52, [
                _createTextVNode(_toDisplayString(Math.round(checklistItemData.value.checklistItemScoreMax * 100) / 100) + "/" + _toDisplayString(Math.round(checklistItemData.value.checklistItemScoreMax * 100) / 100), 1),
                _createElementVNode("span", _hoisted_53, _toDisplayString(Math.round(
                    (checklistItemData.value.checklistItemScoreMax /
                      checklistItemData.value.checklistItemScoreMax) *
                      100,
                  ) || 0) + "%", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createVNode(IncreaseIcon, {
                class: _normalizeClass([
                'info-icon',
                'Cost',
                'tw-text-[#231F20]',
                'tw-scale-[0.856]',
                'tw-mr-[10px]',
              ]),
                color: isExclude.value ? colorTextExclude : 'currentColor'
              }, null, 8, ["color"]),
              _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-assessment-question-increase-1",
              )), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("span", {
                class: _normalizeClass([
                'tw-flex-1 tw-text-[13px]',
                'tw-text-[#01893D] tw-font-[500]',
                isExclude.value ? 'disable-text' : 'tw-text-[#01893D]',
              ])
              }, _toDisplayString(Math.round(
                  (checklistItemData.value.checklistItemScoreMax -
                    checklistItemData.value.checklistItemScore) *
                    100,
                ) / 100), 3)
            ])
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("p", _hoisted_59, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-advanced-modal-description-title-1",
          )), 1),
        _createVNode(WysiwygEditor, {
          modelValue: descriptionData.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((descriptionData).value = $event)),
          "include-image": false,
          "is-disabled": isChecklistCompleted.value,
          placeholder: 
          isChecklistCompleted.value
            ? ''
            : _unref(getComponentUiText)(
                'app-component-assessments-advanced-modal-description-prompt-1',
              )
        ,
          "onUpdate:blur": _cache[5] || (_cache[5] = () => updateDescriptionAssessement(true)),
          "onUpdate:focus": onFocusDes,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (descriptionData.value = $event))
        }, null, 8, ["modelValue", "is-disabled", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("p", _hoisted_61, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-override-question-note-title-1",
          )), 1),
        _createVNode(WysiwygEditor, {
          modelValue: noteData.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((noteData).value = $event)),
          "include-image": false,
          "is-disabled": isChecklistCompleted.value,
          placeholder: 
          isChecklistCompleted.value
            ? ''
            : _unref(getComponentUiText)(
                'app-component-assessments-override-question-note-prompt-1',
              )
        ,
          "onUpdate:blur": _cache[8] || (_cache[8] = () => updateNoteAssessement(true)),
          "onUpdate:focus": onFocus,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (noteData.value = $event))
        }, null, 8, ["modelValue", "is-disabled", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("p", _hoisted_64, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-evidence-button-title-1",
            )), 1),
          _createElementVNode("p", {
            class: "tw-text-[13px] tw-mb-[10px] tw-text-[#387DFF] tw-cursor-pointer tw-underline tw-leading-[145%] tw-font-normal",
            onClick: openEvidenceModal
          }, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-evidence-button-manage-title-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_65, [
          (checklistItemData.value.checklistItemAttachments?.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_unref(getComponentUiText)("app-assessment-notify-notes-empty-1")), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistItemData.value.additionalData as any, ({ type, attachments, text, href }, index) => {
            return (_openBlock(), _createBlock(AssessmentAdditionalInfo, {
              key: index,
              type: type,
              attachments: attachments || [],
              text: text ? text : '',
              href: href ? href : '',
              "checklist-item-id": checklistItemData.value.checklistItemId,
              "is-hovered": onHover.value,
              "max-shown": attachments.length,
              "class-name-attachment": 'tw-flex tw-flex-col tw-gap-[10px]',
              "passkey-question": passkeyQuestion.value,
              onViewAttachments: openEvidenceModal
            }, null, 8, ["type", "attachments", "text", "href", "checklist-item-id", "is-hovered", "max-shown", "passkey-question"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("span", _hoisted_68, "ID: " + _toDisplayString(checklistItemData.value.checklistItemId) + " (" + _toDisplayString(checklistItemData.value.itemMasterId) + ")", 1)
    ])
  ], 64))
}
}

})